<script lang="ts">
	import { resolve } from '$app/paths';
	import { goto } from '$app/navigation';
</script>

<div class="cursor-pointer" onclick={() => goto(resolve('/leaderboard'))} aria-hidden>👑</div>
